import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const products = Array.from({ length: 25 }, (_, i) => ({
  id: i + 1,
  name: `Product ${i + 1}`,
  images: [
    "https://source.unsplash.com/random/200x200?sig=1",
    "https://source.unsplash.com/random/200x200?sig=2",
    "https://source.unsplash.com/random/200x200?sig=3",
    "https://source.unsplash.com/random/200x200?sig=4",
    "https://source.unsplash.com/random/200x200?sig=5",
  ],
}));

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
};

const StockInGrid = () => {
  return (
    <div style={{ margin: "0 auto", padding: "20px" }}>
      <h2 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold", marginBottom: "20px" }}>
        Product Showcase
      </h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "20px" }}>
        {products.map((product) => (
          <div key={product.id} style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "15px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)", backgroundColor: "#fff" }}>
            <Slider {...sliderSettings}>
              {product.images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Product ${product.id} - Image ${index + 1}`}
                  style={{ width: "100%", height: "160px", objectFit: "cover", borderRadius: "6px" }}
                />
              ))}
            </Slider>
            <h3 style={{ textAlign: "center", fontSize: "16px", fontWeight: "600", marginTop: "10px" }}>
              {product.name}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StockInGrid;
